export default __webpack_public_path__ + "static/media/franz-kafka.7437834a.jpg";